const getAuthUrl = () => {
    const hostname = window.location.origin;
    // console.log("getAuthUrl", hostname);
    if (hostname.includes(process.env.REACT_APP_RUTA40_APP_DEV_INTERNAL_URI)) {
        return process.env.REACT_APP_DEV_INTERNAL_AUTH_URI;
    } else if (hostname.includes(process.env.REACT_APP_RUTA40_APP_DEV_EXTERNAL_URI)) {
        return process.env.REACT_APP_DEV_EXTERNAL_AUTH_URI;
    } else if (hostname.includes(process.env.REACT_APP_RUTA40_APP_PROD_URI)) {
        return process.env.REACT_APP_PROD_AUTH_URI;
    } else return process.env.REACT_APP_DEV_EXTERNAL_AUTH_URI;
};

const getApiUrl = () => {
    const hostname = window.location.origin;
    if (hostname.includes(process.env.REACT_APP_RUTA40_APP_DEV_INTERNAL_URI)) {
        return process.env.REACT_APP_DEV_INTERNAL_API_URI;
    } else if (hostname.includes(process.env.REACT_APP_RUTA40_APP_DEV_EXTERNAL_URI)) {
        return process.env.REACT_APP_DEV_EXTERNAL_API_URI;
    } else if (hostname.includes(process.env.REACT_APP_RUTA40_APP_PROD_URI)) {
        return process.env.REACT_APP_PROD_API_URI;
    } else return process.env.REACT_APP_DEV_EXTERNAL_API_URI;
};

const getAppUrl = () => {
    const hostname = window.location.origin;
    if (hostname.includes(process.env.REACT_APP_RUTA40_APP_DEV_INTERNAL_URI)) {
        return process.env.REACT_APP_DEV_INTERNAL_APP_URI;
    } else if (hostname.includes(process.env.REACT_APP_RUTA40_APP_DEV_EXTERNAL_URI)) {
        return process.env.REACT_APP_DEV_EXTERNAL_APP_URI;
    } else if (hostname.includes(process.env.REACT_APP_RUTA40_APP_PROD_URI)) {
        return process.env.REACT_APP_PROD_APP_URI;
    } else return process.env.REACT_APP_DEV_EXTERNAL_APP_URI;
};

const DEFAULT_AUTH_URL = getAuthUrl() + "v1/";
const DEFAULT_API_URL = getApiUrl() + "v1/";
const DEFAULT_APP_URL = getAppUrl() + "v1/";

export const LOGIN_URL = DEFAULT_AUTH_URL + "login";
export const SIGNUP_URL = DEFAULT_AUTH_URL + "signup";

export const FIND_EMAIL_URL = DEFAULT_AUTH_URL + "find_email";
export const MEMBER_INFO_URL = DEFAULT_AUTH_URL + "member";
export const MEMBER_WITHDRAW_URL = DEFAULT_AUTH_URL + "member/withdraw";
export const RESET_PASSWORD_URL = DEFAULT_AUTH_URL + "reset_password";

export const CAR_OWNERS = DEFAULT_APP_URL + "car/owner";
export const OWNERS_MINE_URL = DEFAULT_APP_URL + "car/owners/mine";

export const DOOR_CAR_URL = DEFAULT_APP_URL + "car/";
export const DOOR_CAR_CLOSE_URL = "/door/close";
export const DOOR_CAR_OPEN_URL = "/door/open";
export const SWING_DOOR_CAR_CLOSE_URL = "/door/swing/close";
export const SWING_DOOR_CAR_OPEN_URL = "/door/swing/open";
export const DOOR_STATUS_URL = DEFAULT_APP_URL + "cars/door/status";

export const FIND_EV_STATION_URL = DEFAULT_APP_URL + "openapi/evcs";
